import React, { useMemo, useState, useEffect } from "react"
import { BotonAddProveedorDos, BotonSearchProveedorDos } from '../Plantillas/Botones'
import Select from 'react-select'
import moment from "moment"
import { NOTA_INGRESO } from "../../Global";
import { TIPOS_DOCUMENTO_ASOCIADO_INGRESOS, UNDEFINED_DOC } from "./constants";

const DISABLE_SERIE_CORRETIVO_FOR = [UNDEFINED_DOC, NOTA_INGRESO]

const DatosMovimientoAlmacenIngreso = (props) => {
    const [fechaMovimiento, setFechaMovimiento] = useState(
        props.form?.FechaMovimiento ? moment(props.form.FechaMovimiento).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD")
    )
    const [proveedores, setProveedores] = useState([])
    const tiposDocumentoAsociado = TIPOS_DOCUMENTO_ASOCIADO_INGRESOS;
    const [documentoAsociado, setDocumentoAsociado] = useState(UNDEFINED_DOC)
    const [serie, setSerie] = useState("")
    const [nroDoc, setNroDoc] = useState("")
    const [total, setTotal] = useState("")

    const isDisableSerieCorretivo = useMemo(() => {
        return DISABLE_SERIE_CORRETIVO_FOR.includes(+documentoAsociado);
    }, [documentoAsociado])

    useEffect(() => {
        setSerie("");
        setNroDoc("");
    }, [documentoAsociado])

    useEffect(() => {
        if (!props.onChangeLinkedDocument) {
            return;
        }

        const tipoDocValido = documentoAsociado !== UNDEFINED_DOC;

        if (!tipoDocValido) {
            props.onChangeLinkedDocument(null)
            return;
        }

        props.onChangeLinkedDocument({ serie, correlativo: nroDoc.trim(), tipoDoc: documentoAsociado, total, fechaMovimiento })
    }, [documentoAsociado, serie, nroDoc, total, fechaMovimiento])

    useEffect(() => {
        fetchProveedores()
    }, [])

    useEffect(() => {
        if (props.proveedor?.IdProveedor && !proveedores.find(p => p.IdProveedor === props.proveedor.IdProveedor)) {
            fetchProveedores()
        }
    }, [props.proveedor])

    const fetchProveedores = async () => {
        try {
            const response = await fetch(`/api/proveedores/list/`);
            const data = await response.json();
            const proveedores = data[1] || []
            setProveedores(proveedores.map(proveedor => ({
                ...proveedor,
                value: proveedor.IdProveedor + "-" + proveedor.Ruc,
                label: proveedor.NombreComercial
            })))
        } catch (error) {
            console.error('Error al cargar proveedores:', error)
            setProveedores([])
        }
    }

    const handleChangeFechaMovimiento = (e) => {
        const nuevaFecha = e.target.value
        setFechaMovimiento(nuevaFecha)
        if (props.onFechaChange) {
            props.onFechaChange(nuevaFecha)
        }
    }

    const handleChangeDocumentoAsociado = (e) => {
        setDocumentoAsociado(e.target.value)
        if (props.onDocumentoAsociadoChange) {
            props.onDocumentoAsociadoChange(e.target.value)
        }
    }

    const handleChangeSerie = (e) => {
        const value = e.target.value;
        setSerie(value.toUpperCase())
    }

    const handleChangeNroDoc = (e) => {
        const valor = e.target.value;
        if (!/^\d*$/.test(valor)) {
            return;
        }
        setNroDoc(e.target.value)
    }

    const handleChangeTotal = (e) => {
        const valor = e.target.value;

        if (!/^\d*\.?\d*$/.test(valor)) {
            return;
        }

        setTotal(valor)
    }

    const currentProveedor = useMemo(() => {
        if (!props.proveedor) return null
        
        if (props.proveedor.value && props.proveedor.label) {
            const encontrado = proveedores.find(x => x.value === props.proveedor.value)
            if (encontrado) {
                return encontrado
            }
            return props.proveedor
        }
        
        if (props.proveedor.IdProveedor && props.proveedor.Ruc) {
            const valorBuscado = `${props.proveedor.IdProveedor}-${props.proveedor.Ruc}`
            const encontrado = proveedores.find(x => x.value === valorBuscado)
            if (encontrado) {
                return encontrado
            }
            return {
                ...props.proveedor,
                value: valorBuscado,
                label: props.proveedor.NombreComercial || props.proveedor.NomProveedor || ''
            }
        }
        return null
    }, [proveedores, props.proveedor])

    return (
        <div className="">
            <div className="form-row">
                <div className="form-group col-12 col-sm-8">
                    <label htmlFor="IdTipoTransaccionAlmacen"><strong>Proveedor</strong></label>
                    <Select
                        value={currentProveedor}
                        options={proveedores}
                        onChange={e => props.handleChangeProveedor(e)}
                    />
                </div>

                <div className="form-group col-12 col-sm-4 d-flex justify-content-end">
                    <BotonAddProveedorDos
                        type="button"
                        name="BtnAddProveedor"
                        className="mr-2 botones-proveedor"
                        onClick={props.handleClickNuevoProveedor}
                        title="agregar proveedor"
                    />
                    <BotonSearchProveedorDos
                        type="button"
                        name="BtnAddProveedor"
                        className="botones-proveedor"
                        onClick={props.handleClickBuscarProveedor}
                        title="buscar proveedor"
                    />
                </div>
            </div>

            <div className="form-row">
                <div className="form-group col-12">
                    <label htmlFor="FechaMovimiento"><strong>Fecha Movimiento</strong></label>
                    <input
                        type="date"
                        value={fechaMovimiento}
                        className="form-control"
                        onChange={handleChangeFechaMovimiento}
                    />
                </div>

                <div className="form-group col-12">
                    <label htmlFor="IdDocumentoAsociado"><strong>Documento asociado</strong></label>
                    {tiposDocumentoAsociado ? (
                        <select
                            className="form-control"
                            id="IdDocumentoAsociado"
                            value={documentoAsociado}
                            onChange={handleChangeDocumentoAsociado}
                        >
                            <option value={UNDEFINED_DOC}>Seleccione...</option>
                            {tiposDocumentoAsociado.map(opcion => (
                                <option key={opcion.value} value={opcion.value}>
                                    {opcion.label}
                                </option>
                            ))}
                        </select>
                    ) : (
                        <input
                            type="text"
                            className="form-control"
                            id="IdDocumentoAsociado"
                            value={documentoAsociado}
                            onChange={handleChangeDocumentoAsociado}
                        />
                    )}
                </div>

                {
                    !isDisableSerieCorretivo && (
                        <>
                            <div className="form-group col-12">
                                <label htmlFor="NroSerie"><strong>Serie</strong></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="NroSerie"
                                    value={serie}
                                    onChange={handleChangeSerie}
                                    autoComplete="off"
                                />
                            </div>

                            <div className="form-group col-12">
                                <label htmlFor="NroDocumentoSunat"><strong>Nro Documento</strong></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="NroDocumentoSunat"
                                    value={nroDoc}
                                    onChange={handleChangeNroDoc}
                                    autoComplete="off"
                                />
                            </div>

                            {
                                tiposDocumentoAsociado.find(t => t.value === +documentoAsociado)?.typeTotal && (
                                    <div className="form-group col-12">
                                        <label htmlFor="Total"><strong>Total</strong></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="Total"
                                            value={total}
                                            onChange={handleChangeTotal}
                                            autoComplete="off"
                                        />
                                    </div>
                                )
                            }
                        </>
                    )
                }
            </div>
        </div>
    )
}

export default DatosMovimientoAlmacenIngreso
